import {createApi} from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import store from '../store';
import _ from 'lodash';
import {selectEffectiveOrg} from './session';

const axiosBaseQuery =
  ({baseUrl} = {baseUrl: ''}) =>
  async ({url, method = 'GET', data, params, headers}) => {
    const state = store.getState();
    const {session} = state;
    const effectiveOrg = selectEffectiveOrg(state);
    const _headers = {
      'x-inscope-org': effectiveOrg?.orgId ?? session.currentOrg?.orgId,
      ...headers,
    };
    if (!_.isNil(session.accessToken)) {
      _headers.Authorization = `Bearer ${session.accessToken}`;
    }
    try {
      const result = await axios({
        url: `${baseUrl}${url}`,
        method,
        data,
        params,
        headers: _headers,
      });
      return {data: result.data};
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const disclosuresApiSlice = createApi({
  reducerPath: 'disclosuresApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_DISCLOSURES_API_URL,
  }),
  endpoints: (builder) => ({
    getAccountingTopics: builder.query({
      query: () => ({
        url: '/accounting_topics',
        method: 'GET',
      }),
    }),
    getAccountingTopic: builder.query({
      query: ({topicSlug}) => ({
        url: `/accounting_topic/${topicSlug}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  endpoints,
  useGetAccountingTopicsQuery,
  useGetAccountingTopicQuery,
} = disclosuresApiSlice;
